/*
 * @Author: Ashley.Liu
 * @Date: 2022-05-19 19:48:25
 * @LastEditTime: 2022-12-19 14:45:16
 * @Description: desc
 */
import Vue from 'vue'
import Toolbar from './toolbar.vue'
import { on, off } from '../../utils/dom'

const minSize = 60

function vertical(calcLen, resizeTool, top) {
  let maxT = top.parentNode.clientHeight - resizeTool.offsetHeight

  if (calcLen < minSize) calcLen = minSize
  if (calcLen > maxT - minSize) calcLen = maxT - minSize

  top.style.height = calcLen + 'px'
  return calcLen
}
function horizontal(calcLen, resizeTool, left) {
  var maxT = left.parentNode.clientWidth - resizeTool.offsetWidth

  if (calcLen < minSize) calcLen = minSize
  if (calcLen > maxT - minSize) calcLen = maxT - minSize

  left.style.width = calcLen + 'px'
  return calcLen
}
function getClientXYValue(e, isVertical) {
  return isVertical ? e.clientY : e.clientX
}

function showResize(e) {
  const el = e.target
  el.$resizeToolEl.style.opacity = 1
}
function hideResize(e) {
  const el = e.target
  el.$resizeToolEl.style.opacity = 0
}
export default {
  name: 'resize',
  inserted: function (el, binding) {
    const isVertical = binding.arg === 'vertical'
    // insert resize tool
    const ToolbarComponent = Vue.extend(Toolbar)
    let resizeTool = new ToolbarComponent().$mount()
    const resizeToolEl = resizeTool.$el
    resizeTool.isVertical = isVertical
    resizeTool.showCollapse = binding.modifiers.collapse
    resizeTool.collapseHandler = (isCollapse) => {
      setTimeout(() => {
        if (binding.modifiers.enter) {
          resizeToolEl.style.left = getComputedStyle(el).width
        }
      }, 20)

      binding.value(isCollapse)
    }

    resizeToolEl.title = 'Shrink'
    if (binding.modifiers.enter) {
      resizeTool.resizeToolbarStyleType = 'absolute'
      resizeToolEl.style.opacity = 0
      el.$resizeToolEl = resizeToolEl.$resizeToolEl = resizeToolEl

      on(el, 'mouseenter', showResize)
      on(el, 'mouseleave', hideResize)
      on(resizeToolEl, 'mouseenter', showResize)
      on(resizeToolEl, 'mouseleave', hideResize)

      resizeToolEl.style.position = 'absolute'
      resizeToolEl.style.left = getComputedStyle(el).width
      el.parentNode.appendChild(resizeToolEl)
    } else {
      el.parentNode.insertBefore(resizeToolEl, el.nextSibling)
    }

    let mask
    if (binding.modifiers.mask) {
      mask = document.createElement('div')
      mask.style.position = 'absolute'
      mask.style.left = '0'
      mask.style.top = '0'
      mask.style.bottom = '0'
      mask.style.right = '0'
    }

    resizeToolEl.onmousedown = function (e) {
      mask && document.body.appendChild(mask)
      let startVale = getClientXYValue(e, isVertical)
      let resizeBoxValue
      if (isVertical) {
        resizeBoxValue = resizeToolEl.top = el.getBoundingClientRect().height
      } else {
        resizeBoxValue = resizeToolEl.left = el.getBoundingClientRect().width
      }
      document.onmousemove = function (e) {
        let calcLen =
          resizeBoxValue + (getClientXYValue(e, isVertical) - startVale)
        calcLen = isVertical
          ? vertical(calcLen, resizeToolEl, el)
          : horizontal(calcLen, resizeToolEl, el)
        if (binding.modifiers.enter) {
          isVertical
            ? (resizeToolEl.style.top = calcLen + 'px')
            : (resizeToolEl.style.left = calcLen + 'px')
        }

        binding.value(calcLen)
      }

      document.onmouseleave = document.onmouseup = function () {
        mask && document.body.removeChild(mask)
        document.onmousemove = null
        document.onmouseup = null
        document.onmouseleave = null
        mask = null
        resizeToolEl.releaseCapture && resizeToolEl.releaseCapture()
      }
      resizeToolEl.setCapture && resizeToolEl.setCapture()
      return false
    }
  },
  unbind(el) {
    off(el, 'mouseenter', showResize)
    off(el, 'mouseleave', hideResize)
    off(el.$resizeToolEl, 'mouseenter', showResize)
    off(el.$resizeToolEl, 'mouseleave', hideResize)
    el.$resizeToolEl && (el.$resizeToolEl.$resizeToolEl = null)
    el.$resizeToolEl && (el.$resizeToolEl = null)
  },
}
